export const contracts = [
  {
    id: 'ctr_001',
    organizationId: 'org_3la_labs',
    number: 'CTR-2026-001',
    clientId: 'cli_xpto',
    clientName: 'XPTO Tecnologia',
    startDate: '01/01/2026',
    billingDueDay: 10,
    status: 'Vigente',
    billingCycle: 'Mensal',
    billingCycleCode: 'monthly',
    indexId: 'idx_igpm',
    indexCode: 'IGP-M',
    adjustmentFrequency: 'Anual',
    nextAdjustmentDate: '01/01/2027',
    services: [
      {
        productId: 'prd_suporte',
        productName: 'Suporte mensal',
        quantity: 1,
        unitPrice: 1500,
        total: 1500,
      },
      {
        productId: 'prd_licenca',
        productName: 'Licença 3LA Manager',
        quantity: 5,
        unitPrice: 299,
        total: 1495,
      },
    ],
    totalValue: 2995,
    notes: 'Contrato de suporte e licenças SaaS.',
  },
  {
    id: 'ctr_002',
    organizationId: 'org_3la_labs',
    number: 'CTR-2026-002',
    clientId: 'cli_emsoft',
    clientName: 'Emsoft',
    startDate: '15/02/2026',
    billingDueDay: 15,
    status: 'Vigente',
    billingCycle: 'Mensal',
    billingCycleCode: 'monthly',
    indexId: 'idx_ipca',
    indexCode: 'IPCA',
    adjustmentFrequency: 'Anual',
    nextAdjustmentDate: '15/02/2027',
    services: [
      {
        productId: 'prd_saas_impl',
        productName: 'Implantação de SaaS',
        quantity: 1,
        unitPrice: 8500,
        total: 8500,
      },
      {
        productId: 'prd_suporte',
        productName: 'Suporte mensal',
        quantity: 1,
        unitPrice: 1800,
        total: 1800,
      },
    ],
    totalValue: 10300,
    notes: 'Implantação + suporte pós go-live.',
  },
  {
    id: 'ctr_003',
    organizationId: 'org_3la_labs',
    number: 'CTR-2025-018',
    clientId: 'cli_alpha',
    clientName: 'Studio Alpha',
    startDate: '01/03/2025',
    billingDueDay: null,
    status: 'Encerrado',
    billingCycle: 'Trimestral',
    billingCycleCode: 'quarterly',
    indexId: 'idx_ipca',
    indexCode: 'IPCA',
    adjustmentFrequency: 'Anual',
    nextAdjustmentDate: '—',
    services: [
      {
        productId: 'prd_treinamento',
        productName: 'Treinamento operacional',
        quantity: 2,
        unitPrice: 2500,
        total: 5000,
      },
    ],
    totalValue: 5000,
    notes: 'Contrato encerrado.',
  },
  {
    id: 'ctr_004',
    organizationId: 'org_3la_labs',
    number: 'CTR-2026-003',
    clientId: 'cli_horizonte',
    clientName: 'Horizonte',
    startDate: '01/06/2026',
    billingDueDay: 5,
    status: 'Vigente',
    billingCycle: 'Mensal',
    billingCycleCode: 'monthly',
    indexId: 'idx_igpm',
    indexCode: 'IGP-M',
    adjustmentFrequency: 'Semestral',
    nextAdjustmentDate: '01/12/2026',
    services: [
      {
        productId: 'prd_dev_hora',
        productName: 'Desenvolvimento sob demanda',
        quantity: 40,
        unitPrice: 180,
        total: 7200,
      },
      {
        productId: 'prd_suporte',
        productName: 'Suporte mensal',
        quantity: 1,
        unitPrice: 1200,
        total: 1200,
      },
    ],
    totalValue: 8400,
    notes: 'Pacote de horas + suporte.',
  },
  {
    id: 'ctr_005',
    organizationId: 'org_3la_labs',
    number: 'CTR-2026-004',
    clientId: 'cli_norte',
    clientName: 'Norte Digital',
    startDate: '01/04/2026',
    billingDueDay: 20,
    status: 'Suspenso',
    billingCycle: 'Mensal',
    billingCycleCode: 'monthly',
    indexId: 'idx_fixo',
    indexCode: 'FIXO',
    adjustmentFrequency: 'Anual',
    nextAdjustmentDate: '01/04/2027',
    services: [
      {
        productId: 'prd_suporte',
        productName: 'Suporte mensal',
        quantity: 1,
        unitPrice: 900,
        total: 900,
      },
    ],
    totalValue: 900,
    notes: 'Cliente inativo — contrato suspenso.',
  },
];
